/* global breakpoint */

let productSelect;
let productTypeInfoIcon;
let sidebarWrap;
let sidebarContent;

const hideProductFeatures = (event) => {
  sidebarWrap.classList.remove('show');
    event.target.classList.remove('active');
};

const showProductFeatures = (event) => {
    event.target.classList.add('active');
  const slug = event.target.dataset.productSlug;
  const sidebar = document.getElementById(`sidebar-${slug}`);
  console.log(sidebar);

  sidebarContent.forEach((sidebar) => {
    sidebar.classList.add('is-hidden');
  });
  sidebar.classList.remove('is-hidden');
  sidebarWrap.classList.add('show');
};

const reelOrGrid = () => {
  if (breakpoint.device.name === 'mobile' ||
    breakpoint.device.name === 'tablet') {

    productSelect.classList.remove('is-grid');
    productSelect.classList.add('c-reel');

    // disable info icons tooltips
    //$('.tooltip').tooltipster('disable');
  } else {
    if (productSelect) {
      productSelect.classList.remove('c-reel');
      productSelect.classList.add('is-grid');
      // enable tooltipster on info icon again
      //$('.tooltip').tooltipster('enable');
    }

  }
};

window.addEventListener('click', (event) => {
  if (! event.target.classList.contains('active') && event.target.matches('.js-show-feature-sidebar')) {
    showProductFeatures(event);
  } else if ( event.target.matches('.js-show-feature-sidebar.active') ||
      event.target.matches('.js-hide-product-features') ||
      /**
       * the ! event.target.matches('.slider-element') in the && clause is to avoid triggering the
       * hideProductFeatures() function when clicking on vertical pictures in the photo column.
       * It used to be a weird bug solved by adding this && clause. The main cause of the bug
       * is that 2 elements are depending on the class "active" to be visible or not
       */
      (! event.target.closest('.sidebar-contents') && ! event.target.matches('.slider-element'))
  ) {
    hideProductFeatures(event);
  }
});



//window.addEventListener('resize', reelOrGrid);

const initializeProducts = function() {
  productSelect = document.querySelector('.c-product-grid-select');
  productTypeInfoIcon = document.querySelectorAll('.product-type-info-icon');
  sidebarWrap = document.querySelector('.sidebar-contents');
  sidebarContent = document.querySelectorAll('.c-product-features-sidebar');
  //reelOrGrid();
    
    productTypeInfoIcon.forEach((icon) => {
        icon.classList.add('js-show-feature-sidebar');
    });
}

export {
  initializeProducts,
};
